import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-education-login',
  templateUrl: './education-login.component.html',
  styleUrls: ['./education-login.component.scss']
})
export class EducationLoginComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
      window.scrollTo(0, 0);
  }

}
